import NewsLister from './newsLister';

export default NewsLister;
